import * as auth from "@/api/modules/auth";
import * as authUser from "./modules/authUser";
import * as autoQ from "./modules/autoQ";


export const apiLibrary = {
    auth,
    authUser,
    ...autoQ
};
